import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { userManagementActions } from "../../constants/actionTypes";
import {
  userManagementUploadSuccessAction,
  userManagementUploadErrorAction,
  setUserListData,
  setUserListDataPaginated,
  setUserListError,
  userManagementCreateUserSuccessAction,
  defaultRolesSuccess,
  assignRolesSuccess,
  businessUnitSuccess,
  userManagementEditUserSuccessAction,
  userManagementUpdateUserSuccessAction,
  userActionDataSuccess,
  setUserInfo,
  userManagementDeleteUserSuccessAction,
  errorCreateUser,
  userManagementEditUserErrorAction,
  userManagementUpdateUserErrorAction,
  setUserListLoading,
  setAllUserListData,
  setAllUserListError,
  activeUserDownloadSuccess,
  activeUserDownloadError,
  activeUserDownloadLoading,
} from "../actions/userManagement";
import {
  userManagementUploadApi,
  fetchUserListData,
  userManagementCreateUserApi,
  userManagementDefaultRolesApi,
  userManagementAssignRolesApi,
  userManagementBusinessRolesApi,
  userManagementEditUserApi,
  userManagementUpdateUserApi,
  deleteUserData,
  suspendUser,
  fetchUserInfo,
  activeUserDownloadApi,
} from "../api/userManagement";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { getPaginationParams } from "../../utils";
import { toastNotification } from "../../utils/toast";

function* userManagementUploadMainSagas({ data }) {
  try {
    const userManagementUploadData = yield call(userManagementUploadApi, data);
    if (userManagementUploadData?.status === statusCode?.Created201) {
      yield put(userManagementUploadSuccessAction(userManagementUploadData));
      toastNotification(
        toasterFlags.SUCCESS,
        userManagementUploadData?.data?.Success
      );
      let urlParams = getPaginationParams(10, 1, "-email");
      yield call(fetchUserListData, urlParams);
    } else {
      toastNotification(
        toasterFlags.ERROR,
        userManagementUploadData?.data?.message ||
          userManagementUploadData?.data?.error
      );
      yield put(
        userManagementUploadErrorAction(
          userManagementUploadData?.data?.message ||
            userManagementUploadData?.data?.error
        )
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, error);
  }
}

export function* fetchUserListFunction({ payload }) {
  try {
    yield put(setUserListLoading(true));
    const data = yield call(fetchUserListData, payload);
    if (data.status === statusCode.Ok200) {
      yield put(setUserListData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
    yield put(setUserListLoading(false));
  } catch (err) {
    yield put(setUserListError(err));

    yield put(setUserListLoading(false));
  }
}

export function* fetchAllUserListFunction({ payload }) {
  try {
    yield put(setUserListLoading(true));
    const data = yield call(fetchUserListData, payload);
    if (data.status === statusCode.Ok200) {
      yield put(setAllUserListData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setAllUserListError(data?.data));
    }
    yield put(setUserListLoading(false));
  } catch (err) {
    yield put(setAllUserListError(err));

    yield put(setUserListLoading(false));
  }
}

export function* fetchUserListFunctionPaginated({ payload }) {
  try {
    yield put(setUserListLoading(true));
    const data = yield call(fetchUserListData, payload);
    if (data.status === statusCode.Ok200) {
      yield put(setUserListDataPaginated(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
    yield put(setUserListLoading(false));
  } catch (err) {
    yield put(setUserListError(err));
    yield put(setUserListLoading(false));
  }
}

function* userManagementdefaultRolesMainSaga({ data }) {
  try {
    const userManagementDefaultRolesData = yield call(
      userManagementDefaultRolesApi,
      data
    );
    if (userManagementDefaultRolesData?.status === statusCode.Ok200) {
      yield put(defaultRolesSuccess(userManagementDefaultRolesData));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        `${userManagementDefaultRolesData?.data?.error}`
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

function* userManagementAssignRolesMainSaga({ data }) {
  try {
    const userManagementAssignRolesData = yield call(
      userManagementAssignRolesApi,
      data
    );
    if (userManagementAssignRolesData?.status === statusCode.Ok200) {
      yield put(assignRolesSuccess(userManagementAssignRolesData));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        `${userManagementAssignRolesData?.data?.error}`
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

function* userManagementBusinessRequestMainSaga({ data }) {
  try {
    const userManagementBusinessData = yield call(
      userManagementBusinessRolesApi,
      data
    );
    if (userManagementBusinessData?.status === statusCode.Ok200) {
      yield put(businessUnitSuccess(userManagementBusinessData));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        `${userManagementBusinessData?.data?.error}`
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

function* userManagementAddUserMainSaga({ data }) {
  try {
    const userManagementCreateUserData = yield call(
      userManagementCreateUserApi,
      data
    );
    if (userManagementCreateUserData?.status === statusCode.Created201) {
      yield put(
        userManagementCreateUserSuccessAction(userManagementCreateUserData)
      );
    } else {
      if (userManagementCreateUserData?.data?.message?.email) {
        toastNotification(
          toasterFlags.WARN,
          `${userManagementCreateUserData?.data?.message?.email?.[0]}`
        );
      } else {
        toastNotification(
          toasterFlags.WARN,
          `${userManagementCreateUserData?.data?.message}`
        );
      }
      yield put(errorCreateUser(userManagementCreateUserData?.data));
    }
  } catch (error) {
    yield put(errorCreateUser(error));
  }
}

function* userManagementEditUserMainSaga({ data }) {
  try {
    const userManagementEditUserData = yield call(
      userManagementEditUserApi,
      data
    );
    if (userManagementEditUserData?.status === statusCode.Ok200) {
      yield put(
        userManagementEditUserSuccessAction(userManagementEditUserData)
      );
    } else {
      toastNotification(
        toasterFlags.WARN,
        `${userManagementEditUserData?.data?.message}`
      );
      yield put(
        userManagementEditUserErrorAction(userManagementEditUserData?.data)
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

function* userManagementUpdateUserMainSaga({ data, id }) {
  try {
    const userManagementUpdateUserData = yield call(
      userManagementUpdateUserApi,
      data,
      id
    );
    if (userManagementUpdateUserData?.status === statusCode.Ok200) {
      yield put(
        userManagementUpdateUserSuccessAction(userManagementUpdateUserData)
      );
    } else {
      toastNotification(
        toasterFlags.WARN,
        `${userManagementUpdateUserData?.data?.message}`
      );
      yield put(
        userManagementUpdateUserErrorAction(userManagementUpdateUserData?.data)
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

function* userManagementDeleteUserMainSaga({ data }) {
  try {
    const userManagementDeleteUserData = yield call(deleteUserData, data);
    if (userManagementDeleteUserData?.status === statusCode.Ok200) {
      yield put(
        userManagementDeleteUserSuccessAction(userManagementDeleteUserData)
      );
    } else {
      toastNotification(
        toasterFlags.ERROR,
        `${userManagementDeleteUserData?.data?.message}`
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

function* suspendUserSaga({ data }) {
  try {
    const suspendUserData = yield call(suspendUser, data);
    if (suspendUserData?.status === statusCode.Ok200) {
      yield put(userActionDataSuccess(suspendUserData));
    } else {
      toastNotification(toasterFlags.ERROR, `${suspendUserData?.data?.error}`);
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

export function* userManagementRetrieveUserDetails({ payload }) {
  try {
    const data = yield call(fetchUserInfo, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setUserInfo(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, `${data?.data?.message}`);
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, `${err}`);
  }
}

export function* activeUserDownloadSaga({ payload }) {
  try {
    yield put(activeUserDownloadLoading(true));
    const data = yield call(activeUserDownloadApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(activeUserDownloadSuccess(data?.data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(activeUserDownloadError(data?.data));
    }
    yield put(activeUserDownloadLoading(false));
  } catch (err) {
    yield put(activeUserDownloadError(err));
  }
}

export function* userManagementRootSaga() {
  yield takeLatest(
    userManagementActions.userManagementUploadRequest,
    userManagementUploadMainSagas
  );
  yield takeLatest(
    userManagementActions.userListGetData,
    fetchUserListFunction
  );
  yield takeLatest(
    userManagementActions.allUserListGetData,
    fetchAllUserListFunction
  );
  yield takeLatest(
    userManagementActions.userListGetDataPaginated,
    fetchUserListFunctionPaginated
  );
  yield takeLatest(
    userManagementActions.defaultRolesRequest,
    userManagementdefaultRolesMainSaga
  );
  yield takeLatest(
    userManagementActions.assignRolesRequest,
    userManagementAssignRolesMainSaga
  );
  yield takeLatest(
    userManagementActions.bussinessUnitRequest,
    userManagementBusinessRequestMainSaga
  );
  yield takeLatest(
    userManagementActions.userManagementCreateUserRequest,
    userManagementAddUserMainSaga
  );
  yield takeLatest(
    userManagementActions.userManagementEditUserRequest,
    userManagementEditUserMainSaga
  );
  yield takeLatest(
    userManagementActions.userManagementUpdateUserRequest,
    userManagementUpdateUserMainSaga
  );
  yield takeLatest(
    userManagementActions.userManagementDeleteUser,
    userManagementDeleteUserMainSaga
  );
  yield takeLatest(userManagementActions.suspendUser, suspendUserSaga);
  yield takeLatest(
    userManagementActions.retrieveUserDetail,
    userManagementRetrieveUserDetails
  );
  yield takeLatest(
    userManagementActions.ACTIVE_USER_DOWNLOAD_ACTION,
    activeUserDownloadSaga
  );
}

export default function* rootSaga() {
  yield all([fork(userManagementRootSaga)]);
}
